
import { dateFormats } from '#constants'
import { searchSettingsModule, systemSettingsModule, useDevSettings, useValidationSettings } from '#modules/settings'
import { TagReference } from 'apprise-core/tag'
import { useSettings } from 'apprise-frontend-streams/settings/api'
import { ApproveCycle } from './approvecyclebox'

export type DateFormatOption = {
    name: string
    format: string
}

export type ImageSizeOption = {
    name: string
    val: number
}

export type AppSettings = {

    primaryScheme: TagReference
    secondaryScheme: TagReference
    approveCycle?: ApproveCycle    
    autodelisting: boolean,
    autodelistThreshold: number | undefined,
    autodelistMessage: string | undefined
    submissionAgeCutoff: number | undefined,
    submissionAgeCutoffTenant: number | undefined,
    dateFormat: string
    defaultColumns: string[]
    minPhotoQuality: number
    validatePhotoQuality: boolean
    check: number
    photosRequired: boolean
    excludedFlags: string[] | undefined
    validateIMOChecksum: boolean
    maxVolumeFV: number     // total volume above which a fishing vessel gets a warning.
    maxVolumeCV: number     // total volume above which a carrier vessel gets a warning.
    exportEnabled: boolean
    
}

export const useAppSettings = () => {

    const systemsettings = useSettings<AppSettings>(systemSettingsModule.type)
    const searchsettings = useSettings<AppSettings>(searchSettingsModule.type)
    const validationSettings = useSettings<AppSettings>(useValidationSettings().type)
    const devsettings = useSettings<AppSettings>(useDevSettings().type)

    const self = {

        ...systemsettings

        ,

        ...searchsettings

        ,

        ...validationSettings

        ,

        ...devsettings

        ,

        resolveFormat: () => dateFormats[systemsettings.dateFormat]?.format,

    }


    return self

}

